import { render, staticRenderFns } from "./Framework.vue?vue&type=template&id=321ddc5c&scoped=true&"
import script from "./Framework.vue?vue&type=script&lang=js&"
export * from "./Framework.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321ddc5c",
  null
  
)

export default component.exports